import React from 'react'
import MyRefetchButton from 'components/ui/MyRefetchButton'

const DataTableToolbar = ({ mutate }) => {
  return (
    <div className="mb-2">
      <MyRefetchButton onClick={() => mutate()} />
    </div>
  )
}

export default DataTableToolbar
